import RolePayloadInterface from '../../../../../../../../../types/roles/RolePayload.interface';

export default interface RoleFormInterface extends RolePayloadInterface {}

export const defaultValues: RoleFormInterface = {
  roleName: '',
  permissionIds: [],
};
